import React from "react";
import { useTranslation } from "react-i18next";
import DragAndDropTable from "components/Modules/DragAndDropTable";
import { ModelContext } from "contexts/ModelDetailContext";
import { useContext } from "react";
import { EDIT_ACCESS, FULL_ACCESS, READONLY_ACCESS } from "constants/AccessTypes/AccessTypes";

function ListTable({
	service,
	data,
	handleEdit,
	handleView,
	handleDelete,
	handleDuplicate,
	handleCopy,
	handleServiceLayout,
	handleDragEnd,
	access,
	disable,
}) {
	const [state] = useContext(ModelContext);
	const { t } = useTranslation();

	const editLabel = t("action.edit");
	const viewLabel = t("action.view");
	const duplicateLabel = t("action.duplicate");
	const copyLabel = t("action.copy");
	const removeLabel = t("action.remove");
	const switchLayoutLabel = t("action.switchToServiceLayout", { service });

	return (
		<DragAndDropTable
			data={data}
			isModelEditable={access === FULL_ACCESS || access === EDIT_ACCESS}
			disableDnd={access === READONLY_ACCESS || disable}
			headers={[
				t("label.caption"),
				t("label.type"),
				t("label.compulsory"),
				t("label.captureImage"),
				t("label.alert"),
				t("label.additionalOptions"),
			]}
			columns={[
				{ id: 1, name: "caption", style: { width: "20vw" } },
				{ id: 2, name: "questionType", style: { width: "10vw" } },
				{ id: 3, name: "compulsory", style: { width: "5vw" } },
				{ id: 4, name: "captureImageDisplay", style: { width: "10vw" } },
				{ id: 5, name: "alertDisplay", style: { width: "5vw" } },
				{ id: 6, name: "additional", style: { width: "50vw" } },
			]}
			handleDragEnd={handleDragEnd}
			menuData={[
				{
					name: editLabel,
					handler: handleEdit,
					isDelete: false,
				},
				{
					name: viewLabel,
					handler: handleView,
					isDelete: false,
				},
				{
					name: duplicateLabel,
					handler: handleDuplicate,
					isDelete: false,
				},
				{
					name: copyLabel,
					handler: handleCopy,
					isDelete: false,
				},
				{
					name: switchLayoutLabel,
					handler: handleServiceLayout,
					isDelete: false,
				},
				{
					name: removeLabel,
					handler: handleDelete,
					isDelete: true,
				},
			].filter((x) => {
				if (state?.modelDetail?.isPublished) {
					// Published models are read-only: allow viewing the question detail.
					return (
						x?.name === viewLabel ||
						x?.name === copyLabel ||
						x?.name === switchLayoutLabel
					);
				}
				// View is only offered on published (read-only) models.
				if (x?.name === viewLabel) return false;
				if (disable) return false;
				if (access === FULL_ACCESS) return true;
				if (access === EDIT_ACCESS) {
					if (x.name === editLabel) return true;
					else return false;
				}
				return false;
			})}
		/>
	);
}
export default ListTable;
